// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4d5a4481","453":"419a5d54"}[chunkId] + ".chunk.js";
};